import { FormatLabelStringFn } from '@@partner:types:app'
import { BUSINESS_PROFILE } from '@hive/status'

export const formatBusinessProfileStatus: FormatLabelStringFn = (status: string) => {
  switch (status) {
  case BUSINESS_PROFILE.ACTIVE:
    return { label: 'Активен', color: 'orange' }
  case BUSINESS_PROFILE.BLOCKED:
    return { label: 'Заблокирован', color: 'cyan' }
  case BUSINESS_PROFILE.BLOCKED_INVISIBLE:
    return { label: 'Удалён', color: 'red' }
  case BUSINESS_PROFILE.PENDING:
    return { label: 'Ожидает проверки', color: 'blue' }
  default:
    return { label: 'Неопределённый статус!', color: 'red' }
  }
}
